import styled from 'styled-components'


const TopCreatorsStyle = styled.div.attrs( props => ({ className: props.className }))`
    background-color: var(--lightBlue);
    border-radius: 10px;
    max-width: var(--sp52x);
    width: 100%;
    padding:var(--sp4x);
    margin-top:var(--sp8x);
    
    .single-member {
        justify-content: space-between;
        align-items: center;
        padding-bottom: var(--sp2-5x);
        border-bottom:1px solid #D7EDFF;
        margin-top: var(--sp2-5x);

        .imageCont {
            width: var(--sp5-5x);
            padding-top: var(--sp5-5x);
            border-radius:10px;
            overflow: hidden;
        }

        .info {
            margin-left:var(--sp2x);
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSize}){
        padding:var(--sp3x);
        margin-top:var(--sp3x);
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        max-width: unset;
        margin-bottom: var(--sp4x);
    }
`
export default TopCreatorsStyle
